import {
  TOGGLE_ANALYTICS_PAGE,
  FETCH_GAME_ANALYTICS_REQUEST,
  FETCH_GAME_ANALYTICS_SUCCESS,
  FETCH_GAME_ANALYTICS_FAILURE,
  FETCH_GRAPH_DATA_REQUEST,
  FETCH_GRAPH_DATA_SUCCESS,
  FETCH_GRAPH_DATA_FAILURE,
  FETCH_FULFILLMENT_ANALYTICS_REQUEST,
  FETCH_FULFILLMENT_ANALYTICS_SUCCESS,
  FETCH_FULFILLMENT_ANALYTICS_FAILURE,
  SET_ANALYTICS_ENTITY_ID,
  SET_ANALYTICS_ENTITY_NAME,
} from './actionType'

const initialState = {
  option1: [],
  isAnalyticsPage: false,
  // API loading, data, and error states
  gameAnalyticsLoading: false,
  gameAnalyticsError: null,
  graphDataLoading: false,
  graphDataError: null,
  fulfillmentAnalyticsLoading: false,
  fulfillmentAnalyticsError: null,
  // Data placeholders
  // analyticsData: {
  //   offer_analytics: {
  //     active_vs_inactive: {
  //       total_offers: 4000,
  //       data: [
  //         { name: 'Total Active Offers', value: 1200 },
  //         { name: 'Total Inactive Offers', value: 500 },
  //         { name: 'Total Expired Offers', value: 1000 },
  //       ],
  //       colors: ['#286CBD', '#b0c4de', '#e6e6fa'],
  //     },
  //     budget_analytics: {
  //       total_budget: 100000,
  //       data: [
  //         { name: 'Total Spends', value: 30200 },
  //         { name: 'Remaining Budget', value: 20000 },
  //       ],
  //       colors: ['#286CBD', '#e8f0fe'],
  //     },
  //     count_analytics: {
  //       total_count: 200,
  //       data: [
  //         { name: 'Utilized', value: 165 },
  //         { name: 'Remaining', value: 35 },
  //       ],
  //       colors: ['#4775c0', '#dce6f8'],
  //     },
  //     reward_analytics: {
  //       metrics: [
  //         { title: '# Total Redemption', value: 1572 },
  //         { title: '# Distinct Users', value: 109 },
  //         { title: '# Total Reward Value', value: 2389 },
  //         { title: '# Average Reward', value: 49 },
  //       ],
  //     },
  //   },
  //   monthly_trends: {
  //     data: [
  //       { month: 'JAN', value: 4000 },
  //       { month: 'FEB', value: 7800 },
  //       { month: 'MAR', value: 10900 },
  //       { month: 'APR', value: 11600 },
  //       { month: 'MAY', value: 16400 },
  //       { month: 'JUN', value: 15500 },
  //       { month: 'JUL', value: 12400 },
  //     ],
  //     strokeColor: '#3b82f6',
  //     fillColor: '#3b82f6',
  //   },
  //   game_type_analytics: {
  //     data: [
  //       { title: '# Total Redemption', value: 15072 },
  //       { title: '# Distinct Users', value: 169 },
  //       { title: '# Total Reward Value', value: 2389 },
  //       { title: '# Average Reward', value: 49 },
  //     ],
  //   },
  // },
  analyticsData:{},
  tableData: {},
  gameAnalyticsData: null,
  graphData: null,
  fulfillmentAnalyticsData: null,
  selectedAnalyticsEntity: {
    entityType: null,
    id: null,
  },
  selectedAnalyticsEntityName: "",
}

export const reducer = (state = initialState, { type, payload }) => {
  if (type === FETCH_FULFILLMENT_ANALYTICS_SUCCESS) {
    console.log('payloadm', type, payload)
  }
  switch (type) {
    case TOGGLE_ANALYTICS_PAGE:
      return { ...state, isAnalyticsPage: payload.isAnalyticsPage }

    // Game Analytics
    case FETCH_GAME_ANALYTICS_REQUEST:
      return { ...state, gameAnalyticsLoading: true, gameAnalyticsError: null }
    case FETCH_GAME_ANALYTICS_SUCCESS:
      return {
        ...state,
        gameAnalyticsLoading: false,
        analyticsData: {
          ...state.analyticsData,
          game_type_analytics: payload,
        },
      }
    case FETCH_GAME_ANALYTICS_FAILURE:
      return {
        ...state,
        gameAnalyticsLoading: false,
        gameAnalyticsError: payload,
      }

    // Graph Data
    case FETCH_GRAPH_DATA_REQUEST:
      return { ...state, graphDataLoading: true, graphDataError: null }
    case FETCH_GRAPH_DATA_SUCCESS:
      return {
        ...state,
        graphDataLoading: false,
        analyticsData: { ...state.analyticsData, monthly_trends: payload },
      }
    case FETCH_GRAPH_DATA_FAILURE:
      return { ...state, graphDataLoading: false, graphDataError: payload }

    // Fulfillment Analytics
    case FETCH_FULFILLMENT_ANALYTICS_REQUEST:
      return {
        ...state,
        fulfillmentAnalyticsLoading: true,
        fulfillmentAnalyticsError: null,
      }
    case FETCH_FULFILLMENT_ANALYTICS_SUCCESS:
      return {
        ...state,
        fulfillmentAnalyticsLoading: false,
        analyticsData: {
          ...state.analyticsData,
          offer_analytics: payload.data,
        },
      }
    case FETCH_FULFILLMENT_ANALYTICS_FAILURE:
      return {
        ...state,
        fulfillmentAnalyticsLoading: false,
        fulfillmentAnalyticsError: payload,
      }

    case SET_ANALYTICS_ENTITY_ID:
      return {
        ...state,
        selectedAnalyticsEntity: {
          entityType: payload.entityType,
          id: payload.id,
        },
      }
    case SET_ANALYTICS_ENTITY_NAME:
      return {
        ...state,
        selectedAnalyticsEntityName: payload.name,
      }

    default:
      return state
  }
}
